import React from 'react'
import { Link, StaticQuery, graphql } from 'gatsby'

// Ours
// import ImgSharp from './ImgSharp'
import CarouselBanner from './CarouselBanner'

const CarouselBannerExpertiseListing = props => {
  return (
    <StaticQuery
      query={graphql`
        query CarouselBannerExpertiseListing {
          allWpExpertise(
            limit: 30
            sort: { fields: [parentId, menuOrder], order: ASC }
            filter: { parentId: { ne: null }, slug: { ne: "placeholder" } }
          ) {
            nodes {
              parentId
              title
              id
              databaseId
              slug
              wpParent {
                node {
                  ... on WpExpertise {
                    title
                    menuOrder
                  }
                  slug
                }
              }
              featuredImagePortrait {
                featuredMediaPortrait {
                  altText
                  id
                  databaseId
                  localFile {
                    childImageSharp {
                      id
                      fluid(maxWidth: 1280) {
                        ...GatsbyImageSharpFluid_withWebp_noBase64
                      }
                      square: fluid(
                        maxWidth: 1280
                        maxHeight: 1280
                        cropFocus: CENTER
                      ) {
                        ...GatsbyImageSharpFluid_withWebp_noBase64
                      }
                    }
                  }
                }
              }
              featuredImage {
                node {
                  altText
                  id
                  localFile {
                    childImageSharp {
                      id
                      fluid(maxWidth: 1280) {
                        ...GatsbyImageSharpFluid_withWebp_noBase64
                      }
                      square: fluid(
                        maxWidth: 1280
                        maxHeight: 1280
                        cropFocus: CENTER
                      ) {
                        ...GatsbyImageSharpFluid_withWebp_noBase64
                      }
                    }
                  }
                }
              }
            }
          }
        }
      `}
      render={data => {
        let prevParentId = null
        let prevIndex = null
        let expertiseLists = []
        let featuredImages = []

        data.allWpExpertise.nodes.forEach((expertise, index) => {
          if (expertise.parentId) {
            if (prevParentId !== expertise.parentId) {
              expertiseLists.push({
                title: expertise.wpParent.node.title,
                children: [expertise],
                menuOrder: expertise.wpParent.node.menuOrder,
              })

              let newIndex = prevIndex !== null ? prevIndex + 1 : 0
              prevIndex = newIndex
            } else {
              expertiseLists[prevIndex].children.push(expertise)
            }

            prevParentId = expertise.parentId
          }
        })

        let customTitles = {
          Industries: 'We work for:',
          Services: 'We’re experts in:',
        }

        expertiseLists = expertiseLists.sort(function (a, b) {
          return a.menuOrder - b.menuOrder
        })

        // Get featured images in new order
        expertiseLists.forEach((list, index) => {
          if (list.children) {
            list.children.forEach((expertise, childIndex) => {
              if (expertise.parentId) {
                let featuredImage =
                  expertise.featuredImagePortrait &&
                  expertise.featuredImagePortrait.featuredMediaPortrait
                    ? expertise.featuredImagePortrait.featuredMediaPortrait
                    : expertise.featuredImage.node

                featuredImages.push(featuredImage)
              }
            })
          }
        })

        return (
          <CarouselBanner
            parentClassName="bg-silver"
            leftItems={featuredImages}
            rightItems={expertiseLists}
            rightClassName="flex flex-auto p2 sm-p3 lg-p4 lg-mt3 max-width-3 mx-auto"
            rightContainerComponent={props => {
              return (
                <div className="mxn1 lg-mxn2">
                  <div {...props} />
                </div>
              )
            }}
            rightRenderItem={(cat, settings) => {
              let keyStr = `${cat.id || cat.title}_${settings.index || 0}`
              return (
                <div className="col-12 md-col-6 px1 lg-px2 mb1" key={keyStr}>
                  <h2 className="h5 line-height-4 magenta">
                    {customTitles[cat.title] || cat.title}
                  </h2>
                  <ul className="list-style-none m0 p0 border-top border-gray">
                    {cat.children}
                  </ul>
                </div>
              )
            }}
            rightRenderItemChildren={(item, settings) => {
              let keyStr = `${item.id}_${settings.index}`
              return (
                <li className="block" key={keyStr}>
                  <Link
                    className={`h5 md-h6 lg-h5 block py1 border-bottom border-gray ${
                      settings.active ? 'magenta' : 'black'
                    }`}
                    to={`/${item.wpParent.node.slug}/${item.slug}/`}
                    {...settings.itemProps}>
                    {item.title}
                    {/* TODO Consider thumb instead for small screens
                    <div className="xs-show sm-show md-hide lg-hide">
                      <ImgSharp {...item.featuredImage.node} />
                    </div>
                    */}
                  </Link>
                </li>
              )
            }}
          />
        )
      }}
    />
  )
}

export default CarouselBannerExpertiseListing
